import TechSectionHeader from "./TechSectionHeader";
import TechStackGrid from "./TechStackGrid";
import { designTech } from "./technologies.data";

export default function TechDesignTools() {
  return (
    <section className="tech-section">
      <TechSectionHeader
        title="UI/UX & "
        highlight="Design Tools"
        subtitle="Design-driven development with a focus on user experience."
      />

      <TechStackGrid items={designTech} />
    </section>
  );
}
